import { Routes, Route, Navigate } from "react-router-dom";
import DashboardLayout from "../../components/dashboard-layout";
import TagsPage from "../tags";
import LeadPage from "../leads";
import UsersPage from "../users";
import ToolsPage from "../tools";
import SplitTestsPage from "../split-tests";
import FunnelPage from "../funnel";
import GalleryPage from "../gallery";
import KeywordPage from "../keywords";
import TemplatePage from "../template";
import CustomerPage from "../customers";
import CategoryPage from "../categories";
import MissingInfoPage from "../missing-info";
import UserSettingsPage from "../user-settings";
import { hasAccess } from "../../services/access";
import { ACCESS_CONFIG } from "../../components/strings";
import FunnelsEvaluationPage from "../funnels-evaluation";
import AdsEvaluationPage from "../ads-evaluation";
import SiteSettingsPage from "../site-settings";
import LeadServicePanelPage from "../leadservice-panel";
import LeadAgentPanelView from "../../components/lead-agent/lead-agent-panel-view";
import FulfillmentKpisPage from "../fulfillment-kpis";
import OfferFollowupAgentPanelView from "../../components/offer-followup-agent/offer-followup-agent-panel-view";

const Dashboard = () => {
  return (
    <DashboardLayout>
      {hasAccess(ACCESS_CONFIG.ONLY_AGENT) ? (
        <Routes>
          <Route path="agent/*" element={<LeadAgentPanelView />} />
          <Route
            path="offer-followup-agent"
            element={<OfferFollowupAgentPanelView />}
          />
          <Route path="*" element={<Navigate to="agent" />} />
        </Routes>
      ) : (
        <Routes>
          <Route path="funnels/*" element={<FunnelPage />} />
          <Route path="templates/*" element={<TemplatePage />} />
          <Route path="customers/*" element={<CustomerPage />} />
          <Route path="leads/*" element={<LeadPage />} />
          <Route path="categories/*" element={<CategoryPage />} />
          <Route path="keywords/*" element={<KeywordPage />} />
          <Route path="gallery/*" element={<GalleryPage />} />
          <Route path="tags/*" element={<TagsPage />} />
          <Route path="user/*" element={<UsersPage />} />
          <Route path="settings/*" element={<UserSettingsPage />} />
          <Route path="site-settings/*" element={<SiteSettingsPage />} />
          <Route path="agent" element={<LeadAgentPanelView />} />
          <Route
            path="offer-followup-agent"
            element={<OfferFollowupAgentPanelView />}
          />
          <Route
            path="leadservice-panel/*"
            element={<LeadServicePanelPage />}
          />
          <Route path="evaluation/*" element={<FunnelsEvaluationPage />} />
          <Route path="fulfillment-kpis/*" element={<FulfillmentKpisPage />} />
          <Route path="missing-info/*" element={<MissingInfoPage />} />
          <Route path="ads/evaluation/*" element={<AdsEvaluationPage />} />
          <Route path="*" element={<Navigate to="funnels" />} />
          <Route path="tools/*" element={<ToolsPage />} />
          <Route path="split-tests/*" element={<SplitTestsPage />} />
        </Routes>
      )}
    </DashboardLayout>
  );
};

export default Dashboard;
